import { InsuredGoodsVariantList, } from '@zurich/api/contract';
import { createArrayUtils, UnknownType } from '@zurich/common/utils';
export const insuredGoodsUtils = createArrayUtils(InsuredGoodsVariantList, {
    translationPrefix: 'contract:comprehensive.insuredGoods',
    unknownType: UnknownType.STRING,
});
const getDeductibleVariantTranslation = (deductibleVariant, t, noDeductibleForNaturalCatastrophe, segmentPrefix) => {
    if (deductibleVariant === 'E') {
        return t(`contract:comprehensive.deductibleVariant.E.${segmentPrefix === 'VK' ? 1 : segmentPrefix === 'TK' ? 2 : 3}`, { context: noDeductibleForNaturalCatastrophe ? '' : 'forcesOfNature' });
    }
    return t('contract:comprehensive.deductibleVariant.G');
};
function createDeductibleMotorVariantOptions(t, segmentPrefix, noDeductibleForNaturalCatastrophe) {
    return [
        {
            label: getDeductibleVariantTranslation('G', t, noDeductibleForNaturalCatastrophe, segmentPrefix),
            value: 'G',
            dataName: 'deductibleVariant-G',
        },
        {
            label: getDeductibleVariantTranslation('E', t, noDeductibleForNaturalCatastrophe, segmentPrefix),
            value: 'E',
            dataName: 'deductibleVariant-E',
        },
    ];
}
export const deductibleVariantUtils = {
    createDeductibleMotorVariantOptions,
    getDeductibleVariantTranslation,
};
